module.exports = __webpack_public_path__ + "img/BookCharity.cae64b0c.svg";